
import { UserRoomState, User } from '@/utils/models';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
@Component({ components: { StatusIcon } })
export default class UserMenu extends Vue {
  @Prop() user!: User;
  @Prop() isExitUser!: boolean;
  @Prop() allowed!: boolean;
  @Prop() guestPermission!: 'allow' | 'approve' | 'deny' | undefined;
  get userNameFirstLetter(): string {
    return this.user?.name.charAt(0) ?? '';
  }
  get myUser(): User {
    return this.$store.state.user;
  }
  get isInMyList(): boolean {
    return !!this.myUser?.myList.find((li) => li.id == this.user.id);
  }

  @Emit()
  clickDisplayMiddle() {}
  @Emit()
  moveCloserToRemoteUser() {}
  @Emit()
  clickRegisterMyList() {}
  @Emit()
  clickRemoveMyList() {}
  @Emit()
  knockUser() {
    return this.user;
  }
  @Emit()
  allowGuestUser() {}
  @Emit()
  onOpenTeamsChat() {}
}
